import styled, { keyframes } from "styled-components";
import Container from "features/shared/styles/container/Container.styled";

const spin = keyframes`
   100% {
    transform: rotate(360deg);
   }
  `;

const StyledSpinner = styled(Container)`
  padding: 0;
  width: 30px;
  height: 30px;
  border: 3px solid ${({ theme }) => theme.colors.primary1opacity40};
  border-top-color: ${({ theme }) => theme.colors.primary1};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
export default StyledSpinner;
